import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../../store/hooks';
import { graphqlRequest } from '../../service/graphql-client';
import { GQ_MY_BUILDS } from '../../service/graphql-mutations';

export default function LoadBuildModal({ onClose, onShowProfile }) {
  const { accessToken } = useAppSelector((state) => state.auth);
  const [savedBuilds, setSavedBuilds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    loadSavedBuilds();
  }, []);

  const loadSavedBuilds = async () => {
    try {
      const data = await graphqlRequest(GQ_MY_BUILDS, {}, accessToken);
      
      if (data.myBuilds) {
        setSavedBuilds(data.myBuilds);
      } else {
        setSavedBuilds([]);
      }
    } catch (error) {
      console.error('Error loading builds:', error);
      setErrorMessage(error.message || 'Failed to load saved builds. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <>
        <div className="modal-header">
          <h2 className="modal-title">Loading...</h2>
        </div>
        <div className="modal-body saveBuildModalBody">
          <p>Loading your saved builds...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">Saved Builds</h2>
      </div>
      <div className="modal-body saveBuildModalBody userBuildsBody">
        <div className="backToLogin">
          <a href="#" onClick={onShowProfile} className="link-button">Back to Profile</a>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        {savedBuilds.length > 0 ? (
          <div className="savedBuilds">
            <h3>Would you like to continue one of your saved builds?</h3>
            {savedBuilds.map(build => (
              <a 
                key={build.id}
                className="savedBuild" 
                href={build.productURL + "?build-id=" + build.id}
              >
                <img src={build.image} alt={build.buildName} />
                <div className="buildName">{build.buildName}</div>
                <button className="button orange-button">Choose</button>
              </a>
            ))}
            <div className="savedBuildDivider">or</div>
          </div>
        ) : (
          <div className="no-saved-builds">
            <h3>No saved builds found</h3>
            <p>You don't have any saved builds yet. Start building your dream vehicle!</p>
          </div>
        )}
      </div>
    </>
  );
}